import { Paginator, SortDirection } from '@app/classes';
import { Table } from '@app/modules/table/classes/table.class';
import { MenuColumnItem } from '@app/modules/table/interfaces/menu-column-item.interface';
import { AuthService } from '@app/services';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import { TimeOffType } from '@models/time-off-v3/time-off-type.model';
import { EnrolledEmployeesColumn } from '@time-off-v3/services/type-and-policy-table/columns/enrolled-employees.column';
import { NameColumn } from '@time-off-v3/services/type-and-policy-table/columns/name.column';
import { FutureEnrolledEmployeesColumn } from './columns/future-enrolled-employees.column';

interface TypeAndPolicyTableOptions {
    canReassign: boolean;
}

export class TypeAndPolicyTable extends Table {
    static edit: MenuColumnItem = {
        label: 'edit',
        event: 'edit',
    };
    static assign: MenuColumnItem = {
        label: 'assign',
        event: 'assign',
    };
    static reassign: MenuColumnItem = {
        label: 'reassign',
        event: 'reassign',
    };
    static copy: MenuColumnItem = {
        label: 'copy',
        event: 'copy',
    };
    static delete: MenuColumnItem = {
        label: 'delete',
        event: 'delete',
    };

    showMenuColumnOptions = true;
    timeOffTypeName: string;
    sortDirection: SortDirection = SortDirection.ASC;

    protected defaultSortProperty = 'name';

    constructor(
        protected auth: AuthService,
        public timeOffType: TimeOffType,
        private hasTimeOffImprovement: boolean,
        private options?: TypeAndPolicyTableOptions
    ) {
        super(auth);
        this.timeOffTypeName = timeOffType.name;
        this.links = this.hasTimeOffImprovement;
        this.boot();
    }

    getLink(timeOffPolicy: TimeOffPolicy): (string | number)[] {
        return ['../policy', timeOffPolicy.id];
    }

    setColumns(): void {
        this.columns = this.hasTimeOffImprovement
            ? [new NameColumn(), new EnrolledEmployeesColumn(this.hasTimeOffImprovement)]
            : [
                  new NameColumn(),
                  new EnrolledEmployeesColumn(this.hasTimeOffImprovement),
                  new FutureEnrolledEmployeesColumn(),
              ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            TimeOffPolicy.with(['currentlyAssignedNonTerminatedEmployees', 'futureAssignedNonTerminatedEmployees'])
                .where('timeOffTypeId', this.timeOffType.id)
                .limit(50),
            { pageSize: 50 }
        );
    }

    getMenuColumnOptionsForRow(timeOffPolicy: TimeOffPolicy): MenuColumnItem[] {
        // Show `reassign` only if we checked the number of the policies for the type (canReassign) and if here are employees attached
        // to the policy
        const optional =
            this.options?.canReassign && !!timeOffPolicy.employeeCount ? [TypeAndPolicyTable.reassign] : [];

        return [
            TypeAndPolicyTable.edit,
            TypeAndPolicyTable.assign,
            TypeAndPolicyTable.copy,
            TypeAndPolicyTable.delete,
            ...optional,
        ];
    }
}
